import useSWR from 'swr'
import { containerRepository } from '~/src/repositories'

/**
 * useGetContainer
 * @param containerId {number} コンテナID
 */
export const useGetContainer = (containerId: number) => {
  const { data, error, mutate } = useSWR([`/containers/${containerId}`, containerId], () =>
    containerRepository.getContainer(containerId)
  )

  return { data, error, mutate }
}
